import React from 'react';
import './HeroSection.css';

export default function HeroSection({ onGetStarted }) {
  return (
    <section className="hs-root">
      {/* Background */}
      <div className="hs-bg-grid" />
      <div className="hs-bg-glow" />

      <div className="hs-inner">

        {/* LEFT: Copy */}
        <div className="hs-left">

          <h1 className="hs-title">
            Foreign-Owned LLC<br />
            <em>Compliance, Fully Filed.</em>
          </h1>

          <p className="hs-sub">
            Taxsuites is the compliance hub for foreign-owned U.S. LLCs and corporations.
            We prepare and file your EIN and ITIN applications, extract transactions
            straight from your bank statements to complete Form 5472 and the pro forma
            Form 1120, fax everything to the IRS with delivery confirmation, and track
            your state annual report deadlines so nothing slips — all from one dashboard.
          </p>

          <div className="hs-actions">
            <button className="hs-btn-primary" onClick={onGetStarted}>
              Start Filing
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="hs-chips">
              <span>✓ EIN &amp; ITIN applications</span>
              <span>✓ 5472 &amp; 1120 auto-filed</span>
              <span>✓ Annual reports tracked</span>
              <span>✓ From $50</span>
            </div>
          </div>

        </div>

        {/* RIGHT: Four service cards */}
        <div className="hs-right">
          <div className="hs-tiles">

            {/* EIN */}
            <div className="hs-tile">
              <div className="hs-tile-header">
                <div className="hs-tile-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M4 21V8l8-5 8 5v13" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 21v-6h6v6" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 12h.01M15 12h.01M9 8h.01M15 8h.01" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="hs-tile-header-title">EIN</span>
                <span className="hs-tile-badge hs-tile-badge--done">Issued</span>
              </div>
              <div className="hs-tile-body">
                <div className="hs-tile-detail">XX-XXXXXXX</div>
                <p className="hs-tile-desc">
                  We file your IRS Employer Identification Number application directly, no SSN required.
                </p>
                <div className="hs-tile-divider" />
                <div className="hs-tile-meta">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                    <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  Typically issued in 5–10 business days
                </div>
              </div>
            </div>

            {/* ITIN */}
            <div className="hs-tile">
              <div className="hs-tile-header">
                <div className="hs-tile-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <rect x="2.5" y="5" width="19" height="14" rx="2" stroke="#ffffff" strokeWidth="1.8"/>
                    <circle cx="8.5" cy="12" r="2" stroke="#ffffff" strokeWidth="1.8"/>
                    <path d="M14 10h5M14 14h3" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="hs-tile-header-title">ITIN</span>
                <span className="hs-tile-badge hs-tile-badge--done">Approved</span>
              </div>
              <div className="hs-tile-body">
                <div className="hs-tile-detail">Application filed</div>
                <p className="hs-tile-desc">
                  Individual Taxpayer ID applications prepared and submitted for foreign owners and officers.
                </p>
                <div className="hs-tile-divider" />
                <div className="hs-tile-meta">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Certified Acceptance Agent review included
                </div>
              </div>
            </div>

            {/* Form 5472 & 1120 */}
            <div className="hs-tile">
              <div className="hs-tile-header">
                <div className="hs-tile-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2v6h6" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 13h6M9 17h6" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="hs-tile-header-title">Form 5472 &amp; 1120</span>
                <span className="hs-tile-badge hs-tile-badge--done">Filed</span>
              </div>
              <div className="hs-tile-body">
                <div className="hs-tile-detail">Faxed to IRS · Delivered</div>
                <p className="hs-tile-desc">
                  We pull transactions straight from your bank statements and auto-complete both forms for you.
                </p>
                <div className="hs-tile-divider" />
                <div className="hs-tile-meta">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Fax confirmation receipt saved to your dashboard
                </div>
              </div>
            </div>

            {/* Annual Report Tracking */}
            <div className="hs-tile">
              <div className="hs-tile-header">
                <div className="hs-tile-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="#ffffff" strokeWidth="1.8"/>
                    <path d="M16 2v4M8 2v4M3 10h18" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="hs-tile-header-title">Annual Report</span>
                <span className="hs-tile-badge hs-tile-badge--pending">Due Mar 1</span>
              </div>
              <div className="hs-tile-body">
                <div className="hs-tile-detail">Delaware · Tracked</div>
                <p className="hs-tile-desc">
                  State deadlines tracked automatically with reminders so your entity stays in good standing.
                </p>
                <div className="hs-tile-divider" />
                <div className="hs-tile-meta">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path d="M12 8v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  Email &amp; dashboard reminders 30 days out
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}